import VAppMain from './VAppMain.vue';
import VAppLayout from './VAppLayout.vue';

export { VAppMain, VAppLayout };
export default VAppLayout;
